export default "__VITE_ASSET__0c94349f__"